import { usePFBRoutes } from '@/hooks/usePFBRoutes';
import Constants from '@/utils/constants';
import localStorage from '@/utils/localStorageUtil';

export async function isLoggedIn(key) {
	try {
		const value = localStorage.getItem(key);
		if (value !== null) {
			return value.isLoggedIn;
		}
		return false;
	} catch (error) {
		return false;
	}
}

export async function saveData(key, data) {
	try {
		localStorage.setItem(key, data);
	} catch (error) {
		return {};
	}
}

export const setDestinationURL = async () => {
	const currentRouteData = usePFBRoutes.getData();

	if (currentRouteData?.data.isAuthenticated) {
		saveData(Constants.DESTINATION_URL, {
			path: window.location.pathname,
			search: window.location.search,
		});
	}
};

export async function getData(key) {
	try {
		return localStorage.getItem(key);
	} catch (error) {
		return {};
	}
}

export async function removeData(key) {
	try {
		return localStorage.removeItem(key);
	} catch (error) {
		return {};
	}
}
